/* unplugin-vue-components disabled */import { render } from "./TransferElement.vue?vue&type=template&id=464d60fc&ts=true"
import script from "./TransferElement.vue?vue&type=script&lang=ts"
export * from "./TransferElement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__